import { render, staticRenderFns } from "./warninfo.vue?vue&type=template&id=6b29653d&scoped=true&"
import script from "./warninfo.vue?vue&type=script&lang=ts&"
export * from "./warninfo.vue?vue&type=script&lang=ts&"
import style0 from "./warninfo.vue?vue&type=style&index=0&id=6b29653d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29653d",
  null
  
)

export default component.exports